export default __webpack_public_path__ + "static/media/logo.9bd7bf61.png";